// Hardcoded to production to ensure parity with the mobile app
export const API_BASE_URL = 'https://pondy-backend.greensky-719d52e6.centralindia.azurecontainerapps.io/api';

export const fetchListings = async (type = 'all', username = null) => {
    let url = `${API_BASE_URL}/data?type=${type}`;
    if (username) url += `&viewer_username=${username}`;
    const response = await fetch(url);
    return response.json();
};

export const fetchSingleAd = async (retailId) => {
    const response = await fetch(`${API_BASE_URL}/ad/${retailId}`);
    return response.json();
};

export const searchListings = async (query) => {
    const response = await fetch(`${API_BASE_URL}/search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
    });
    return response.json();
};

export const loginUser = async (credential, password) => {
    const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential, password })
    });
    return response.json();
};

export const signupUser = async (userData) => {
    const response = await fetch(`${API_BASE_URL}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData)
    });
    return response.json();
};

export const toggleFavorite = async (username, retailId) => {
    const response = await fetch(`${API_BASE_URL}/toggle_favorite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, retail_id: retailId })
    });
    return response.json();
};

export const fetchConnectPosts = async (sort = 'latest', category = null, username = null) => {
    let url = `${API_BASE_URL}/connect?sort=${sort}`;
    if (category) url += `&category=${category}`;
    if (username) url += `&username=${username}`;
    const response = await fetch(url);
    return response.json();
};

export const fetchRecommendations = async (username, limit = 10) => {
    const response = await fetch(`${API_BASE_URL}/recommendations?username=${username}&limit=${limit}`);
    return response.json();
};

export const fetchFeaturedPromotions = async (limit = 15) => {
    const response = await fetch(`${API_BASE_URL}/featured_promotions?limit=${limit}`);
    return response.json();
};

export const createPost = async (username, text, images = [], location = '', options = {}) => {
    const response = await fetch(`${API_BASE_URL}/connect`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            username,
            text,
            images,
            location,
            ...options
        })
    });
    return response.json();
};

export const setAlert = async (username, query) => {
    const response = await fetch(`${API_BASE_URL}/set_alert`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, query })
    });
    return response.json();
};

export const fetchUserAds = async (username) => {
    const url = username
        ? `${API_BASE_URL}/my_ads?username=${username}`
        : `${API_BASE_URL}/my_ads`;
    const response = await fetch(url);
    return response.json();
};

export const followUser = async (follower, target) => {
    const response = await fetch(`${API_BASE_URL}/follow`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ follower, target })
    });
    return response.json();
};

export const fetchNotifications = async (username) => {
    try {
        if (!username) return [];
        const response = await fetch(`${API_BASE_URL}/notifications?username=${username}`);
        if (!response.ok) throw new Error('Failed to fetch notifications');
        let data = await response.json();

        // Map backend notification to frontend format
        return data.map(item => ({
            id: item.RelatedID,
            title: item.Message,
            image: item.Image,
            user: item.Sender_Name || 'Notification',
            timestamp: item.Timestamp,
            type: item.Type || 'system',
            category: item.Category,
            description: item.Description,
            isRead: item.IsRead
        }));

    } catch (error) {
        console.error("Error fetching notifications:", error);
        return [];
    }
};

export const fetchNews = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/news`);
        if (!response.ok) throw new Error('Failed to fetch news');
        return response.json();
    } catch (error) {
        console.error("Error fetching news:", error);
        return [];
    }
};

export const placeBid = async (timestamp, username, amount) => {
    const response = await fetch(`${API_BASE_URL}/connect/bid`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ timestamp, username, amount })
    });
    return response.json();
};

export const endAuction = async (timestamp, username) => {
    const response = await fetch(`${API_BASE_URL}/connect/auction/end`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ timestamp, username })
    });
    return response.json();
};

export const getAuctionContact = async (timestamp, username) => {
    const response = await fetch(`${API_BASE_URL}/auction/contact?timestamp=${timestamp}&username=${username}`);
    return response.json();
};

export const votePoll = async (timestamp, username, optionIndex) => {
    const response = await fetch(`${API_BASE_URL}/connect/poll/vote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ timestamp, username, option_index: optionIndex })
    });
    return response.json();
};

export const toggleEventInterest = async (timestamp, username, action) => {
    const response = await fetch(`${API_BASE_URL}/connect/event/interest`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ timestamp, username, action })
    });
    return response.json();
};

export const fetchSlotifyBookings = async (retailId, dateStr) => {
    const response = await fetch(`${API_BASE_URL}/slotify/ad_bookings/${retailId}?date=${dateStr}`);
    return response.json();
};

export const createSlotifyBooking = async (bookingData) => {
    const response = await fetch(`${API_BASE_URL}/bookings`, { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bookingData)
    });
    return response.json();
};

export const respondToSlotifyBooking = async (bookingId, status, reason = '') => {
    const response = await fetch(`${API_BASE_URL}/slotify/respond`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ booking_id: bookingId, status, reason })
    });
    return response.json();
};

export const updateSlotifyAd = async (retailId, username, updateFields) => {
    const response = await fetch(`${API_BASE_URL}/slotify/ads/${retailId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, update_fields: updateFields })
    });
    return response.json();
};

export const toggleFollow = async (follower, target) => {
    const response = await fetch(`${API_BASE_URL}/follow`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ follower, target })
    });
    return response.json();
};

export const blockUser = async (username, target) => {
    const response = await fetch(`${API_BASE_URL}/user/block`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, target })
    });
    return response.json();
};

export const unblockUser = async (username, target) => {
    const response = await fetch(`${API_BASE_URL}/user/unblock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, target })
    });
    return response.json();
};

export const fetchBlockedUsers = async (username) => {
    const response = await fetch(`${API_BASE_URL}/user/blocked?username=${username}`);
    return response.json();
};

export const fetchUserProfile = async (username) => {
    const response = await fetch(`${API_BASE_URL}/user/profile?username=${username}`);
    return response.json();
};

export const updateUserProfile = async (oldUsername, updates) => {
    const response = await fetch(`${API_BASE_URL}/user/update_profile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ old_username: oldUsername, updates })
    });
    return response.json();
};

export const updateUserCategory = async (username, category) => {
    const response = await fetch(`${API_BASE_URL}/user/update_category`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, category })
    });
    return response.json();
};

export const fetchInterestedEvents = async (username) => {
    const response = await fetch(`${API_BASE_URL}/connect/events/interested?username=${username}`);
    return response.json();
};

export const postReview = async (reviewData) => {
    const response = await fetch(`${API_BASE_URL}/ads/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reviewData)
    });
    return response.json();
};

export const fetchReviews = async (retailId) => {
    const response = await fetch(`${API_BASE_URL}/ads/reviews?retail_id=${retailId}`);
    return response.json();
};

export const fetchRatingStats = async (retailId) => {
    const response = await fetch(`${API_BASE_URL}/ads/ratings/stats?retail_id=${retailId}`);
    return response.json();
};

export const fetchScratchCards = async (username) => {
    const response = await fetch(`${API_BASE_URL}/payment/scratch_cards?username=${username}`);
    return response.json();
};

export const claimScratchCard = async (username, cardId) => {
    const response = await fetch(`${API_BASE_URL}/payment/scratch_cards/claim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, card_id: cardId })
    });
    return response.json();
};

export const fetchScratchCardOffers = async () => {
    const response = await fetch(`${API_BASE_URL}/payment/scratch_card_offers`);
    return response.json();
};

export const fetchScratchCardsHistory = async (username) => {
    const response = await fetch(`${API_BASE_URL}/payment/scratch_cards/history?username=${username}`);
    return response.json();
};

export const incrementScratchOfferView = async (retailId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/payment/scratch_card_offers/${retailId}/view`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.json();
    } catch (e) {
        return { success: false };
    }
};

export const fetchBrokerStatus = async (username) => {
    const response = await fetch(`${API_BASE_URL}/user/broker_status?username=${username}`);
    return response.json();
};

export const renewBrokerPack = async (username, planId, transactionId = '') => {
    const response = await fetch(`${API_BASE_URL}/user/broker_pack/renew`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, plan_id: planId, transaction_id: transactionId })
    });
    return response.json();
};

export const submitFeedback = async (feedbackData) => {
    const response = await fetch(`${API_BASE_URL}/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
    });
    return response.json();
};

export const updateNotificationSettings = async (username, settings) => {
    const response = await fetch(`${API_BASE_URL}/user/notification_settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, ...settings })
    });
    return response.json();
};

